<template lang="html">
  <Col>
    <Hero
      :title="title"
      :description="description"
      :backgroundImage="backgroundImage"
      :image="isMobile ? '/static/dashboard.png' : null"
      contentWidth="526px"
      imageWidth="500px"
      minHeight="690px"
      :slant="isMobile"
      :isMobile="isMobile"
      :scrollOffset="0"
      :titleStyles="{ 'font-size': '2.2rem' }">
    </Hero>
    <!-- <AssetTypesSection></AssetTypesSection> -->
    <PlatformComponentsList></PlatformComponentsList>
    <SecuritySection></SecuritySection>
    <!-- <ScheduleDemo :isMobile="isMobile"></ScheduleDemo> -->
    <EmailSignupSection :isMobile="isMobile"></EmailSignupSection>
    <AggressiveCTA :isMobile="isMobile"></AggressiveCTA>
  </Col>
</template>
<script>
import Hero from './Hero';
import PlatformComponentsList from './PlatformComponentsList';
import platformComponents from '../services/platformComponents';
import ScheduleDemo from './ScheduleDemo';
import SecuritySection from './SecuritySection';
import AggressiveCTA from './AggressiveCTA';
import EmailSignupSection from './EmailSignupSection';
import AssetTypesSection from './AssetTypesSection';

export default {
  components: { Hero, PlatformComponentsList, ScheduleDemo, SecuritySection, AggressiveCTA, EmailSignupSection, AssetTypesSection },
  props: ['windowWidth', 'isMobile'],
  data() {
    return {
      platformComponents,
      title: 'Powerful Insights on your Personal Finances & Investments',
      description: 'Vue Finance gives you a complete and accurate picture of your finances. Track your net worth, build custom reports, and make confident, data-driven financial decisions.',
      backgroundColor: 'linear-gradient(rgb(25, 45, 74), rgb(22, 40, 66))',
    };
  },
  computed: {
    backgroundImage() {
      return !this.isMobile ?
      "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.5), rgba(0,0,0,0.4), rgba(0,0,0,0.1)), url('/static/reviewing-finances-in-coffee-shop.JPG')" :
      'rgb(38, 49, 65)';
    },
  },
};
</script>
<style lang="css" scoped>
.nav-card {
  padding: 18px;
  color: #ffffffeb; /*easier on the eyes*/
}

.nav-card:hover {
  transform: translateY(-3px);
  box-shadow: 2px 1px 16px rgba(0,0,0,0.05);
  cursor: pointer;
}

.page-section-title {
  text-align: center;
  font-size: 2rem;
  padding: 32px 8px 62px 8px;
}

.page-section {
  margin-bottom: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Landingv2.vue